module.exports = __webpack_public_path__ + "img/sparklight-logo.58d4b236.jpg";